// src/App.js
import React, { useState } from 'react';
import HomeScreen from './components/HomeScreen';
import VerticalVideoCreator from './components/VerticalVideoCreator';
import VoiceSynthesisCreator from './components/VoiceSynthesisCreator';
import ImageGenerationScreen from './components/ImageGenerationScreen';
import CreateScreen from './components/CreateScreen';
import EditScreen from './components/EditScreen';
import SaveScreen from './components/SaveScreen';
import VoiceNarrationScreen from './components/VoiceNarrationScreen';
import ShortMovieScreen from './components/ShortMovieScreen';
import MusicGenerator from './components/MusicGenerator';
import Login from './components/Login';
import Signup from './components/Signup';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home, Plus, Edit, Save } from 'lucide-react';
import { auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';

const App = () => {
  const [activeTab, setActiveTab] = useState('home');
  const [activeScreen, setActiveScreen] = useState('home'); // home, vertical-video, voice-synthesis, image-generation
  const [user] = useAuthState(auth);

  const handleBackToHome = () => {
    setActiveScreen('home');
  };

  const handleSelectTemplate = (id) => {
    if (id === 1) {
      setActiveScreen('vertical-video');
    } else if (id === 2) {
      setActiveScreen('voice-synthesis');
    }
  };

  const handleSelectCategory = (category) => {
    if (category === 'image') {
      setActiveScreen('image-generation');
    } else if (category === 'voice') {
      setActiveScreen('voice-narration');
    } else if (category === 'video') {
      setActiveScreen('movie-generation');
    } else if (category === 'music') {
      setActiveScreen('music-generator');
    }
  };

  const renderContent = () => {
    switch(activeScreen) {
      case 'vertical-video':
        return <VerticalVideoCreator onBack={handleBackToHome} />;
      case 'voice-synthesis':
        return <VoiceSynthesisCreator onBack={handleBackToHome} />;
      case 'image-generation':
        return <ImageGenerationScreen onBack={handleBackToHome} />;
      case 'voice-narration':
        return <VoiceNarrationScreen onBack={handleBackToHome} />;
      case 'movie-generation':
        return <ShortMovieScreen onBack={handleBackToHome} />;
      case 'music-generator':
       return <MusicGenerator onBack={handleBackToHome} />;
      default:
        switch(activeTab) {
          case 'home':
            return <HomeScreen 
              onSelectTemplate={handleSelectTemplate} 
              onSelectCategory={handleSelectCategory}
            />;
          case 'create':
            return <CreateScreen />;
          case 'edit':
            return <EditScreen />;
          case 'save':
            return <SaveScreen />;
          default:
            return <HomeScreen 
              onSelectTemplate={handleSelectTemplate}
              onSelectCategory={handleSelectCategory}
            />;
        }
    }
  };

  // 以下は変更なし
  const TabButton = ({ name, icon, label }) => (
    <button 
      className={`flex flex-col items-center p-2 ${activeTab === name ? 'text-blue-500 border-t-2 border-blue-500' : 'text-gray-500'}`}
      onClick={() => setActiveTab(name)}
    >
      {icon}
      <span className="text-xs mt-1">{label}</span>
    </button>
  );

  return (
    <Router>
      <div className="flex flex-col h-screen bg-gray-100">
        {/* Header */}
        <header className="bg-white p-4 shadow flex justify-between items-center">
          <div>
            <h1 className="text-xl font-bold">Saku.ai</h1>
            <p className="text-xs text-gray-500 mt-1">最も使いやすいクリエイティブAIエージェント</p>
          </div>
          
          {/* ログインと新規登録ボタン */}
          <div className="flex items-center">
            {/* ログインしていない場合 */}
            {!user && (
              <>
                <a href="/login" className="flex items-center bg-black text-white px-3 py-2 rounded hover:bg-gray-800 mr-2 text-sm">
                  <i className="fas fa-sign-in-alt mr-2"></i>
                  <span className="hidden sm:inline">ログイン</span>
                </a>
                <a href="/signup" className="flex items-center bg-gray-200 text-gray-800 px-3 py-2 rounded hover:bg-gray-300 text-sm">
                  <i className="fas fa-user-plus mr-2"></i>
                  <span className="hidden sm:inline">新規登録</span>
                </a>
              </>
            )}
            {/* ログインしている場合 */}
            {user && (
              <a href="/logout" className="flex items-center bg-gray-200 text-gray-800 px-3 py-2 rounded hover:bg-gray-300 text-sm ml-2">
                <i className="fas fa-sign-out-alt mr-2"></i>
                <span className="hidden sm:inline">ログアウト</span>
              </a>
            )}
          </div>
        </header>
        
        {/* Main Content */}
        <main className="flex-1 overflow-y-auto">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/*" element={renderContent()} />
          </Routes>
        </main>
        
        {/* Footer Navigation - Hide when in special screens */}
        {activeScreen === 'home' && (
          <nav className="bg-white border-t flex justify-around py-2">
            <TabButton name="home" icon={<Home size={24} />} label="ホーム" />
            <TabButton name="create" icon={<Plus size={24} />} label="作成" />
            <TabButton name="edit" icon={<Edit size={24} />} label="編集" />
            <TabButton name="save" icon={<Save size={24} />} label="保存" />
          </nav>
        )}
      </div>
    </Router>
  );
};

export default App;